import { Trans, useTranslation } from 'react-i18next';

export default function Background({
  heading,
  subheading,
  clientLogoPath,
  clientName,
  component,
  i18nKeyPrefix = 'header',
}) {
  const { t } = useTranslation('translation', {
    keyPrefix: i18nKeyPrefix,
  });

  return (
    <div className="login-stack w-full max-w-md mx-auto px-3 py-4 md:z-10 md:m-auto space-y-4">
      <div className="login-stack-card shadow-sm px-5 py-6">
        <div className="w-full flex mb-5 justify-center items-center">
          {clientLogoPath && (
            <img
              className="object-contain client-logo-size client-logo-shadow rounded-[25px] border-[0.1px] border-white"
              src={clientLogoPath}
              alt={clientName}
            />
          )}
          <span className="flex mx-5 alternate-arrow"></span>
          <img
            className="object-contain brand-only-logo client-logo-size"
            alt={t('logo_alt')}
          />
        </div>
        <h1
          className="flex text-center justify-center mb-2 font-bold text-xl text-gray-900 login-stack-heading"
          id="login-header"
        >
          {heading}
        </h1>
        {subheading && (
          <p
            className="text-center login-stack-subheading text-sm font-normal px-2"
            id="login-subheader"
          >
            <Trans
              i18nKey={i18nKeyPrefix + '.' + subheading}
              defaults={subheading}
              values={{ clientName: clientName }}
            />
          </p>
        )}
      </div>

      <div className="login-stack-card shadow-sm px-5 py-5">{component}</div>
    </div>
  );
}
